export const TenantExceptions = {
  EmailAlreadyExists: 'IdentityEmailAlreadyExists',
  UserHasRoleAdmin: 'UserHasRoleAdmin',
  UserHasRoleCustomer: 'UserHasRoleCustomer',
};
